import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CruiseBundleCreate, CruiseBundleUpdate } from '~/components/Cruises/pages/Bundles/types';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

interface SaveBundleParams {
  id?: string;
  data: CruiseBundleCreate | CruiseBundleUpdate;
}

export function useSaveBundle() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: SaveBundleParams) => {
      if (id) {
        return await bundlesService.update(id, data);
      }
      return await bundlesService.create(data as CruiseBundleCreate);
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.lists() });
      if (variables.id) {
        queryClient.invalidateQueries({ queryKey: bundleQueryKeys.detail(variables.id) });
      }
    },
  });
}
